import React from "react";
import styled, { css } from "styled-components";
import * as Tabs from "@radix-ui/react-tabs";

import Modal from "../../../Modal";
import TabWrapper from "../../../Tabs";
import Button, { ButtonWrapper } from "../../../Button";
import ListItem from "../ListItem";
import { rem } from "polished";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip as ReactTooltip } from "react-tooltip";
import {
  addMounting,
  addSink,
  getSinks,
  removeSink,
  updateSinkGap,
  updateSinkPos,
  updateSinkVariantValue,
} from "../../../../lib/redux/slices/sink-slice";
import {
  addMeasurement,
  removeMeasurement,
} from "../../../../lib/redux/slices/measurements-slice";
import { getMeasurement } from "../../../Builder/SinkGroup/measurement-utils";
import {
  changeCurrentEvent,
  getDimensions,
  getLineAlignment,
  getTileShape,
} from "../../../../lib/redux/slices/dimensions-slice";
import { getCanvasValues, wrtRatio } from "../../../../utils/canvas";
import config from "../../../../utils/config";
import { nanoid } from "nanoid";
import ItemDetailModal from "../ItemDetailModal";
import { useUpdateCart } from "../../../../hooks/use-update-cart";

const Sinks = ({ data, montering = {}, stage }) => {
  const [open, onSetModal] = React.useState(false);

  const sinks = useSelector(getSinks);
  const currentShape = useSelector(getTileShape);
  const dimensions = useSelector(getDimensions);
  const dispatch = useDispatch();
  const [selectedItem, setSelectedItem] = React.useState([]);
  const [openDetailModal, onSetDetailModal] = React.useState(false);
  const lineAlignment = useSelector(getLineAlignment);
  const { updateCart } = useUpdateCart();

  const monteringOption = montering.options[0]

  const removeSelected = (selectedIndex, uniqId) => {
    const remainingItems = sinks.filter((_, index) => index !== selectedIndex);
    dispatch(removeSink(remainingItems));
    updateCart((storeData) => ({
      ...storeData,
      sinks: remainingItems,
    }));
    dispatch(removeMeasurement({ index: uniqId, type: "sinks" }));
  };

  const attachSink = (sink) => {
    const uniqID = nanoid();
    setSelectedItem(sink);
    const image = new Image();
    image.src = sink.image;
    image.onload = () => {
      const width = image.naturalWidth;
      const height = image.naturalHeight;
      const { canvasLeft, canvasRight, canvasTop, canvasBottom } =
      getCanvasValues(dimensions, currentShape, lineAlignment);
      
      dispatch(
        addSink({
          variant: {
            blandare: {
              id: "blandare",
              label: "Hål för blandare",
              value: false,
            },
            // pump_vanster: {
            //   id: "pump_vanster",
            //   label: "Pump vänster",
            //   value: false,
            // },
            // pump_hoger: {
            //   id: "pump_hoger",
            //   label: "Pump höger",
            //   value: false,
            // },
          },
          sinkGap: config.defaultTileGap,
          mounting: monteringOption,
          width: width,
          height: height,
          uniqId: uniqID,
          ...sink,
        })
      );

      updateCart((storeData) => ({
        ...storeData,
        sinks: [
          ...storeData.sinks,
          {
            variant: {
              blandare: {
                id: "blandare",
                label: "Hål för blandare",
                value: false,
              },
              // pump_vanster: {
              //   id: "pump_vanster",
              //   label: "Pump vänster",
              //   value: false,
              // },
              // pump_hoger: {
              //   id: "pump_hoger",
              //   label: "Pump höger",
              //   value: false,
              // },
            },
            sinkGap: config.defaultTileGap,
            mounting: monteringOption,
            width: width,
            height: height,
            uniqId: uniqID,
            ...sink,
          },
        ],
      }));



      const upcomingGroupID = `element-sinks-${uniqID}`;

      setTimeout(() => {
        const element = stage.current.findOne(`#${upcomingGroupID}`);

        dispatch(
          addMeasurement(
            getMeasurement({
              element,
              groupWidth: width,
              groupHeight: height,
              currentShape,
              canvasLeft,
              canvasRight,
              canvasTop,
              canvasBottom,
            })
          )
        );
      }, 10);
    };
  };

  return (
    <Layout>
      {sinks.length ? (
        <SinksList
          data={sinks}
          removeSelected={removeSelected}
          montering={montering}
          stage={stage}
          openDetailModal={openDetailModal}
          onSetDetailModal={onSetDetailModal}
          setSelectedItem={setSelectedItem}
        />
      ) : null}
      <ButtonWrapper>
        <Button onClick={() => onSetModal(!open)}>VÄLJ</Button>
      </ButtonWrapper>
      <Modal
        wrapperId={`modal`}
        isOpen={open}
        overlayClick
        handleClose={() => onSetModal(false)}
        styles={{
          maxWidth: "90%",
          maxHeight: "90%",
          height: "100%",
          width: "100%",
          borderRadius: 0,
        }}
        parentStyles={{
          zIndex: 9999,
        }}
        title={data.label}
      >
        {data && (
          <TabWrapper isSticky={true}>
            <Tabs.Root
              className="TabsRoot"
              defaultValue={Object.keys(data.options)[0]}
            >
              <Tabs.List className="TabsList" aria-label={data.label}>
                {Object.entries(data.options).map((sink) => {
                  return (
                    <Tabs.Trigger
                      className="TabsTrigger"
                      value={sink[0]}
                      key={sink[0]}
                    >
                      {sink[1].label}
                    </Tabs.Trigger>
                  );
                })}
              </Tabs.List>

              {Object.entries(data.options).map((sink) => {
                return (
                  <Tabs.Content
                    className="TabsContent"
                    value={sink[0]}
                    key={sink[0]}
                  >
                    <ListItem
                      data={sink[1].options}
                      onHandleSet={attachSink}
                      onModalClose={() => onSetModal(false)}
                      setSelectedItem={setSelectedItem}
                      onSetDetailModal={onSetDetailModal}
                    />
                  </Tabs.Content>
                );
              })}
            </Tabs.Root>
          </TabWrapper>
        )}
      </Modal>
      <ItemDetailModal
        selectedItem={selectedItem}
        openDetailModal={openDetailModal}
        onSetDetailModal={onSetDetailModal}
      />
    </Layout>
  );
};
export default Sinks;

const Layout = styled.div``;

const SinksList = ({
  data,
  removeSelected,
  montering,
  stage,
  openDetailModal,
  onSetDetailModal,
  setSelectedItem,
}) => {
  const [open, onSetModal] = React.useState(false);
  const [currentIndex, setCurrentIndex] = React.useState(null);

  const currentShape = useSelector(getTileShape);
  const dimensions = useSelector(getDimensions);
  const lineAlignment = useSelector(getLineAlignment);
  const { updateCart } = useUpdateCart();

  const { canvasLeft, canvasRight, canvasTop, canvasBottom } = getCanvasValues(
    dimensions,
    currentShape,
    lineAlignment
  );
  const isLeft = currentShape === "left";
  const isRight = currentShape === "right";
  const isSimple = currentShape === "simple";

  const dispatch = useDispatch();

  const onChangeVariation = (
    e,
    itemIndex,
    variantId,
    holeIndex,
    itemUniqueID,
    item
  ) => {
    const { checked } = e.target;

    dispatch(updateSinkVariantValue({ checked, itemIndex, variantId }));

    updateCart((storeData) => {
      const updatedSinks = storeData.sinks.map((sink, index) => {
        if (index === itemIndex && variantId in sink.variant) {
          return {
            ...sink,
            variant: {
              ...sink[variantId],
              [variantId]: {
                ...sink.variant[variantId],
                value: checked,
              },
            },
          };
        }

        return sink;
      });

      return {
        ...storeData,
        sinks: updatedSinks,
      };
    });

    const upcomingGroupID = `element-sinks-${itemUniqueID}`;
    const element = stage.current.findOne(`#${upcomingGroupID}`);

    if (checked)
      dispatch(
        addMeasurement(
          getMeasurement({
            element,
            groupWidth: element.width(),
            groupHeight: element.height(),
            currentShape,
            canvasLeft,
            canvasRight,
            canvasTop,
            canvasBottom,
            [variantId]: checked,
            tileGap: item.sinkGap,
          })
        )
      );
    else {
      // We are only using holes (1 & 3) in first(1)-middle(none)-last(3)
      // But in the loop we are looping from 0, 1, 2 where 1 is the first hole & 2 is the last hole
      // so map 2 to 3 for removing the last hole
      const identifier = `${upcomingGroupID}-hole-${
        holeIndex > 1 ? 3 : holeIndex
      }`;

      dispatch(
        removeMeasurement({ actualIdentifier: identifier, type: "holes" })
      );
    }
  };

  const onChangeSinkGap = (value, index) =>
    dispatch(updateSinkGap({ value, index }));

  const handleMounting = (value) => {
    dispatch(addMounting({ value, index: currentIndex }));
    updateCart((storeData) => ({
      ...storeData,
      sinks: storeData.sinks.map((sink, index) => {
        if (index === currentIndex) {
          return {
            ...sink,
            mounting: value,
          };
        }

        return sink;
      }),
    }));
  };

  const onChangeCoordinate = (value, item, index, itemUniqueID, tileGap) => {
    const { x, y, rotation, offsetX, offsetY } = item;

    const pump_vanster =
      "variant" in item &&
      item.variant["pump_vanster"] &&
      item.variant.pump_vanster.value;

    const pump_hoger =
      "variant" in item &&
      item.variant["pump_hoger"] &&
      item.variant.pump_hoger.value;

    const upcomingGroupID = `element-sinks-${itemUniqueID}`;
    const element = stage.current.findOne(`#${upcomingGroupID}`);

    const { canvasLeft, canvasRight } = getCanvasValues(
      dimensions,
      currentShape,
      lineAlignment
    );

    dispatch(
      updateSinkPos({
        index: index,
        x: [0, 180].includes(rotation) ? Math.round(value) : x,
        y: ![0, 180].includes(rotation) ? Math.round(value) : y,
        rotation: rotation,
        offsetX: offsetX,
        offsetY: offsetY,
      })
    );

    dispatch(
      addMeasurement(
        getMeasurement({
          element,
          groupWidth: element.width(),
          groupHeight: element.height(),
          pump_hoger,
          pump_vanster,
          currentShape,
          canvasLeft,
          canvasRight,
          canvasTop,
          canvasBottom,
          tileGap: item.sinkGap,
        })
      )
    );
    dispatch(changeCurrentEvent("input"));
  };

  return (
    <SinksListLayout>
      {data.map((item, index) => {
        const { x, y, rotation, width, sinkGap, offsetX, offsetY } = item;
        
        const tileGap = parseInt(sinkGap);
        
        const imageRatio = config.imageRatio;
        const value = [0, 180].includes(rotation) ? x : y;
        let min = width * imageRatio + tileGap / imageRatio + 7;
        let max = 0;

        if (isSimple) {
          max = [0, 180].includes(rotation)
            ? wrtRatio(canvasTop, "*") - min
            : wrtRatio(canvasLeft, "*") - min;
        }

        if (isLeft) {
          if ([0, 180].includes(rotation)) {
            max = wrtRatio(canvasTop, "*") - min;
          }
          if ([90, -90].includes(rotation)) {
            max = wrtRatio(canvasLeft, "*") - min;
          }
          if ([270].includes(rotation)) {
            max = wrtRatio(canvasRight, "*") - min;
          }

          if (
            wrtRatio(x, "/") <
              canvasBottom - offsetX + wrtRatio(tileGap, "/") &&
            wrtRatio(y, "/") >=
              canvasRight - offsetY - wrtRatio(tileGap, "/") &&
            [0].includes(rotation)
          ) {
            max = wrtRatio(canvasBottom, "*") - min;
          }
        }

        if (isRight) {
          if ([0, 180].includes(rotation)) {
            max = wrtRatio(canvasTop, "*") - min;
          }
          if ([-90, 90].includes(rotation)) {
            max = wrtRatio(canvasLeft, "*") - min;
          }
          if ([270].includes(rotation)) {
            max = wrtRatio(canvasRight, "*") - min;
          }
          if (
            wrtRatio(x, "/") > canvasBottom &&
            wrtRatio(y, "/") > canvasLeft - offsetY - wrtRatio(tileGap - 7, "/")
          ) {
            if ([0].includes(rotation)) {
              min =
                canvasBottom * config.defaultRatio +
                width * imageRatio +
                tileGap / imageRatio +
                7;
              max =
                wrtRatio(canvasTop, "*") -
                (width * imageRatio + tileGap / imageRatio + 7);
            } else {
              max = wrtRatio(canvasRight, "*") - min;
            }
          }
        }
        return (
          <div className="item" key={index}>
            <div className="item-details">
              <div
                className="item-header"
                onClick={() => {
                  setSelectedItem(item);
                  onSetDetailModal(!openDetailModal);
                }}
              >
                <img src={item.image} alt={item.label} width={60} />
                <div className="title">{item.label}</div>
              </div>
              <div className="remove">
                <div
                  className="close"
                  onClick={() => removeSelected(index, item.uniqId)}
                >
                  X
                </div>
              </div>
            </div>
            <div className="dimension">
              <label>
                <span>Sida</span>
                {/* <input
                  type="number"
                  step={1}
                  min={Math.round(min)}
                  max={Math.round(max)}
                  value={Math.round(value)}
                  onChange={(e) => {
                    let value = parseInt(e.target.value);
                    onChangeCoordinate(value, item, index, item.uniqId);
                  }}
                /> */}
                <InputField
                  {...{
                    min,
                    max,
                    value,
                    item,
                    index,
                    onChangeCoordinate,
                  }}
                />
              </label>
              <label>
                <span>Fram</span>
                <input
                  type="number"
                  value={item.sinkGap}
                  onChange={(e) => {
                    onChangeSinkGap(e.target.value, index);
                  }}
                />
              </label>
            </div>

            <div className="sink-variant">
              <h5>Montering</h5>
              <div className="mounting">
                {/* <h5
                data-tooltip-id={`mounting-${item.uniqId}`}
                className="tooltip"
              >
                Assembly
              </h5> */}
                <ReactTooltip
                  className="tooltip-content"
                  id={`mounting-${item.uniqId}`}
                  place="top"
                  content="Select available mounting methods"
                />
                <div className="mounting-details">
                  <div className="image">
                    <img
                      src={item.mounting.image}
                      alt={item.mounting.label}
                      width={100}
                    />
                  </div>
                  <div
                    className="title"
                    onClick={() => {
                      setCurrentIndex(index);

                      onSetModal(!open);
                    }}
                  >
                    {item.mounting.label}
                  </div>
                </div>
              </div>
              <div className="sink-variant-item">
                {item.variant &&
                  Object.values(item.variant).map((variant, i) => {
                    return (
                      <div className="checkboxField" key={i}>
                        <label>
                          <input
                            type="checkbox"
                            value={variant.value}
                            checked={variant.value}
                            name={`${item.ptype}-${index}`}
                            onChange={(e) =>
                              onChangeVariation(
                                e,
                                index,
                                variant.id,
                                i,
                                item.uniqId,
                                item
                              )
                            }
                          />
                          <span className="checkbox" />
                          {variant.label}
                        </label>
                      </div>
                    );
                  })}
              </div>
            </div>

            {/* <ButtonWrapper>
              <Button className="text-capitalize">{montering.label}</Button>
            </ButtonWrapper> */}
          </div>
        );
      })}

      <Modal
        wrapperId="modal"
        isOpen={open}
        overlayClick
        handleClose={() => {
          onSetModal(false);
          setCurrentIndex(null);
        }}
        styles={{
          maxWidth: "90%",
          maxHeight: "90%",
          height: "100%",
          width: "100%",
          borderRadius: 0,
        }}
        parentStyles={{
          zIndex: 9999,
        }}
        title={montering.label}
      >
        <ListItem
          onHandleSet={handleMounting}
          data={montering.options}
          onModalClose={() => onSetModal(false)}
        />
      </Modal>
    </SinksListLayout>
  );
};

const InputField = ({ min, max, value, item, index, onChangeCoordinate }) => {
  const [inputValue, setInputValue] = React.useState(0);

  React.useEffect(() => {
    setInputValue(Math.round(value));
  }, [value]);

  const verifyLimit = (e) => {
    const value = Math.round(e.target.value) || 0;

    const limitValue = (min, max, val) => Math.min(Math.max(min, val), max);

    const limit = (minValue, maxValue) => {
      const limitedValue = limitValue(minValue, maxValue, value);
      setInputValue(Math.round(limitedValue));
      return Math.round(limitedValue);
    };

    onChangeCoordinate(limit(min, max), item, index, item.uniqId);
  };

  const handleChange = (e) => {
    let value = Math.round(e.target.value);
    setInputValue(value);
  };

  return (
    <input
      type="number"
      step={1}
      min={Math.round(min)}
      max={Math.round(max)}
      value={inputValue}
      onBlur={(e) => verifyLimit(e)}
      onChange={(e) => handleChange(e)}
    />
  );
};

const SinksListLayout = styled.div`
  ${({ theme }) => css`
    .item {
      margin-top: ${rem(20)};

      + .item {
        border-top: 1px solid ${theme.colors.gray[400]};
        margin-top: ${rem(20)};
        padding-top: ${rem(20)};
      }

      .item-details {
        display: flex;
        flex-direction: row;
        align-items: center;

        .item-header {
          flex-grow: 1;
          display: flex;
          flex-direction: row;
          align-items: center;

          .title {
            margin-left: ${rem(15)};
          }
        }
      }

      .dimension {
        margin-top: ${rem(30)};

        label {
          display: flex;
          align-items: center;
          justify-content: center;

          + label {
            margin-top: ${rem(15)};
          }

          span {
            flex: 0 0 60px;
            max-width: 60px;
          }

          input {
            width: 100%;
            border: 1px solid ${theme.colors.gray[400]};
            min-height: 30px;
            padding: 0 5px;
          }
        }
      }

      .sink-variant {
        margin-top: ${rem(15)};

        h5 {
          margin-bottom: ${rem(15)};
        }
        &-item {
          .checkboxField {
            input {
              display: none;
              &:checked {
                + .checkbox {
                  background-color: ${theme.colors.primary};
                  border-color: ${theme.colors.primary};
                }
              }
            }
            label {
              display: flex;
              align-items: center;

              .checkbox {
                width: 100%;
                height: 20px;
                border: 1px solid ${theme.colors.gray[300]};
                background-color: transparent;
                transition: 0.3s ease all;
                display: inline-block;
                flex: 0 0 35px;
                max-width: 35px;
                margin-right: ${rem(15)};
              }
            }

            + .checkboxField {
              margin-top: ${rem(15)};
            }
          }
        }
      }

      .mounting {
        margin: ${rem(15)} 0;
        h5 {
          border-bottom: 1px dotted ${theme.colors.primary};
          cursor: help;
          display: inline-block;
          margin-bottom: 10px;

          &:hover {
            color: ${theme.colors.primary};
          }
        }
        .title {
          text-transform: capitalize;
          display: inline-block;
          cursor: pointer;
          color: ${theme.colors.primary};

          &:hover {
            opacity: 0.9;
          }
        }

        .tooltip-content {
          font-size: 12px;
        }
      }
      .remove {
        flex: 0 0 15px;
        max-width: 15px;
        text-align: center;
        cursor: pointer;
      }
    }
  `}
`;
